import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { PASSES_LANDING } from "@/settings/constant";
import { Button } from "@bookips/solvook-ui-library";
import { Typography } from "@mui/material";
import Link from "next/link";
import { Subjects } from "src/api/product";
import { TabMessageBox } from "./PurchaseLayouts";
const PurchaseNoFreepassTab = (param)=>{
    let { product  } = param;
    var _product_source;
    var _product_source_subject;
    const subject = (_product_source_subject = (_product_source = product.source) === null || _product_source === void 0 ? void 0 : _product_source.subject) !== null && _product_source_subject !== void 0 ? _product_source_subject : Subjects.EN;
    const passesLandingUrl = "".concat(PASSES_LANDING, "?subject=").concat(subject);
    const handleClick = ()=>{
        //mx-205
        mixpanelEvent("CTA Button Clicked", {
            Position: "구매모듈",
            "Button Type": "Freepass Purchase Module",
            "Button Name": "무제한 이용하기",
            "Button URL": passesLandingUrl
        });
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(TabMessageBox, {
                sx: {
                    mb: 2.5
                },
                children: /*#__PURE__*/ _jsxs(Typography, {
                    variant: "subtitle1",
                    sx: {
                        color: "text.title"
                    },
                    children: [
                        "해당 상품은 '전용 패스'를 구매 후",
                        /*#__PURE__*/ _jsx("br", {}),
                        "이용할 수 있어요."
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Link, {
                href: passesLandingUrl,
                children: /*#__PURE__*/ _jsx(Button, {
                    size: "large",
                    variant: "contained",
                    fullWidth: true,
                    onClick: handleClick,
                    children: "무제한 이용하기"
                })
            })
        ]
    });
};
export default PurchaseNoFreepassTab;
